import React from 'react'

interface StarFilledProps extends React.SVGProps<SVGSVGElement> {}
const StarFilled: React.FC<StarFilledProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      fill='none'
    >
      <path
        fill='#FFB800'
        d='m15.073 5.162-4.534-.659L8.512.395a.574.574 0 0 0-1.025 0L5.46 4.503l-4.534.66a.57.57 0 0 0-.316.974l3.28 3.199-.774 4.516a.57.57 0 0 0 .828.601L8 12.322l4.055 2.133a.57.57 0 0 0 .829-.602l-.775-4.516 3.28-3.199a.57.57 0 0 0-.316-.975Z'
      />
    </svg>
  )
}

export default StarFilled
